__turbopack_context__.v({
  "label": "Label-module__EBop_W__label",
});
